export function shouldBlockCheckout(termsCheckboxSelector?: string): boolean {
  if (!termsCheckboxSelector) {
    return false;
  }

  const checkboxElement = document.querySelector(termsCheckboxSelector) as
    | HTMLInputElement
    | undefined;

  if (!checkboxElement) {
    return false;
  }

  if (
    checkboxElement.checked === undefined ||
    checkboxElement.checked === null
  ) {
    return false;
  }

  return !checkboxElement.checked;
}
